/** All available DTOs keys for "finance" module */
export enum FinanceDtoKeysEnum {
  /** Balance report column descriptor base response body */
  BALANCE_REPORT_COLUMN_DTO = 'finance/balance-report-column.dto',
  /** Balance report cost center column descriptor response body */
  BALANCE_REPORT_COST_CENTER_COLUMN_DTO = 'finance/balance-report-cost-center-column.dto',
  /** Balance report field column descriptor response body */
  BALANCE_REPORT_FIELD_COLUMN_DTO = 'finance/balance-report-field-column.dto',
  /** Balance report month column descriptor response body */
  BALANCE_REPORT_MONTH_COLUMN_DTO = 'finance/balance-report-month-column.dto',
  /** Balance report unit column descriptor response body */
  BALANCE_REPORT_UNIT_COLUMN_DTO = 'finance/balance-report-unit-column.dto',
  BALANCE_REPORT_QUERY_DTO = 'finance/balance-report-query.dto',
  BALANCE_REPORT_DATA_BY_COST_CENTERS_DTO = 'finance/balance-report-data-by-cost-centers.dto',
  BALANCE_REPORT_DATA_BY_UNITS_DTO = 'finance/balance-report-data-by-units.dto',
  BALANCE_REPORT_DATA_VALUE_DTO = 'finance/balance-report-data-value.dto',
  BALANCE_REPORT_MONTH_DATA_DTO = 'finance/balance-report-month-data.dto',
  BALANCE_REPORT_ROW_DTO = 'finance/balance-report-row.dto',
  BALANCE_REPORT_DTO = 'finance/balance-report.dto',
  BALANCE_REPORT_CUSTOM_ROW_FIND_DTO = 'finance/balance-report-custom-row-find.dto',
  BALANCE_REPORT_CUSTOM_ROW_FORM_DTO = 'finance/balance-report-custom-row-form.dto',
  BALANCE_REPORT_ROW_TOKEN_DTO = 'finance/balance-report-row-token.dto',
  /** Balance report "Balance Sheet" widget API query parameters */
  BALANCE_REPORT_SHEET_QUERY_DTO = 'finance/balance-report-sheet-query.dto',
  /** Balance report "Balance Sheet" widget API response body */
  BALANCE_REPORT_SHEET_DTO = 'finance/balance-report-sheet.dto',
  BALANCE_REPORT_SETTINGS_FIND_DTO = 'finance/balance-report-settings-find.dto',
  BALANCE_REPORT_SETTINGS_FORM_DTO = 'finance/balance-report-settings-form.dto',
  /** Balance report sorting response body */
  BALANCE_REPORT_SORTING_FIND_DTO = 'finance/balance-report-sorting-find.dto',
  /** Balance report sorting create/update API request body */
  BALANCE_REPORT_SORTING_FORM_DTO = 'finance/balance-report-sorting-form.dto',
  /** Balance report sorting APIs URL parameters */
  BALANCE_REPORT_SORTING_PARAMS_DTO = 'finance/balance-report-sorting-params.dto',
  /** Balance sheet report API item response body */
  BALANCE_SHEET_REPORT_ITEM_DTO = 'finance/balance-sheet-report-item.dto',
  /** Balance sheet report API query parameters */
  BALANCE_SHEET_REPORT_QUERY_DTO = 'finance/balance-sheet-report-query.dto',
  /** Balance sheet report API response body */
  BALANCE_SHEET_REPORT_DTO = 'finance/balance-sheet-report.dto',
  /** Balance sheet widget API details item response body */
  BALANCE_SHEET_WIDGET_ITEM_DTO = 'finance/balance-sheet-widget-item.dto',
  /** Balance sheet widget API query parameters */
  BALANCE_SHEET_WIDGET_QUERY_DTO = 'finance/balance-sheet-widget-query.dto',
  /** Balance sheet widget API response body */
  BALANCE_SHEET_WIDGET_DTO = 'finance/balance-sheet-widget.dto',
  // OFD
  KKT_FIND_DTO = 'finance/kkt-find.dto',
  KKT_FORM_DTO = 'finance/kkt-form.dto',
  KKT_FORM_EXTERNAL_DTO = 'finance/kkt-form-external.dto',
  KKT_PAGE_DTO = 'finance/kkt-page.dto',
  KKT_FILTERS_DTO = 'finance/kkt-filters.dto',
  KKT_QUERY_DTO = 'finance/kkt-query.dto',
  KKT_ACTIVITY_SUMS_DTO = 'finance/kkt-activity-sums.dto',
  OPERATOR_FIND_DTO = 'finance/operator-find.dto',
  OPERATOR_FORM_DTO = 'finance/operator-form.dto',
  OPERATOR_PAGE_DTO = 'finance/operator-page.dto',
  OPERATOR_FILTERS_DTO = 'finance/operator-filters.dto',
  OPERATOR_QUERY_DTO = 'finance/operator-query.dto',
  RECEIPT_FIND_DTO = 'finance/receipt-find.dto',
  RECEIPT_FORM_DTO = 'finance/receipt-form.dto',
  RECEIPT_PAGE_DTO = 'finance/receipt-page.dto',
  RECEIPT_FILTERS_DTO = 'finance/receipt-filters.dto',
  RECEIPT_QUERY_DTO = 'finance/receipt-query.dto',
  RECEIPT_SUMS_FIND_DTO = 'finance/receipt-sums-find.dto',
  RECEIPT_CHART_FIND_DTO = 'finance/receipt-chart-find.dto',
  REVENUE_REPORT_FIND_DTO = 'finance/revenue-report-find.dto',
  REVENUE_REPORT_PAGE_DTO = 'finance/revenue-report-page.dto',
  REVENUE_REPORT_FILTERS_DTO = 'finance/revenue-report-filters.dto',
  REVENUE_REPORT_QUERY_DTO = 'finance/revenue-report-query.dto',
  NDS_FIND_DTO = 'finance/nds-find.dto',
  /** "Payment/Outgoing" report API response body item */
  PAYMENT_OUTGOING_ITEM_DTO = 'finance/payment-outgoing-item.dto',
  /** "Payment/Outgoing" report API query parameters */
  PAYMENT_OUTGOING_QUERY_DTO = 'finance/payment-outgoing-query.dto',
}
